import { io } from 'socket.io-client';

let socket = null;

export const getSocket = () => {
  if (!socket) {
    const apiUrl = import.meta.env.VITE_API_BASE_URL || 'http://localhost:5000/api';
    const serverUrl = apiUrl.replace(/\/api\/?$/, '');

    socket = io(serverUrl, {
      path: '/socket.io',
      transports: ['polling', 'websocket'],
      autoConnect: true,
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 2000
    });
  }
  return socket;
};

export const joinShopRoom = (shopId) => {
  const s = getSocket();
  if (s && shopId) {
    if (s.connected) {
      s.emit('join:shop', shopId);
    } else {
      s.once('connect', () => {
        s.emit('join:shop', shopId);
      });
    }
  }
};

export const leaveShopRoom = (shopId) => {
  const s = getSocket();
  if (s && shopId) {
    s.emit('leave:shop', shopId);
  }
};
